import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFarmById,
  fetchFarms,
  fetchLivestock,
  fetchLivestockById,
  fetchLivestockDigitalTwin,
  fetchLivestockDigitalTwins,
  fetchLivestockMeasurements,
  fetchLivestockProcessingMethods,
  fetchLivestockSurveys,
} from "../../../api/digitalTwin/farms/farmsApi";
import {
  fetchFarmByIdFailure,
  fetchFarmByIdStart,
  fetchFarmByIdSuccess,
  fetchFarmsFailure,
  fetchFarmsStart,
  fetchFarmsSuccess,
  fetchLivestockByIdFailure,
  fetchLivestockByIdStart,
  fetchLivestockByIdSuccess,
  fetchLivestockDigitalTwinFailure,
  fetchLivestockDigitalTwinStart,
  fetchLivestockDigitalTwinSuccess,
  fetchLivestockDigitalTwinsFailure,
  fetchLivestockDigitalTwinsStart,
  fetchLivestockDigitalTwinsSuccess,
  fetchLivestockFailure,
  fetchLivestockMeasurementsFailure,
  fetchLivestockMeasurementsStart,
  fetchLivestockMeasurementsSuccess,
  fetchLivestockProcessingMethodsFailure,
  fetchLivestockProcessingMethodsStart,
  fetchLivestockProcessingMethodsSuccess,
  fetchLivestockStart,
  fetchLivestockSuccess,
  fetchLivestockSurveysFailure,
  fetchLivestockSurveysStart,
  fetchLivestockSurveysSuccess,
} from "../../../store/features/digitalTwin/farms/farmsSlice";

const getErrorMessage = (error) =>
  error.response?.data?.message || error.message;

function* fetchFarmsSaga(action) {
  try {
    const farmsData = yield call(fetchFarms, action.payload);
    yield put(fetchFarmsSuccess(farmsData));
  } catch (error) {
    yield put(fetchFarmsFailure(getErrorMessage(error)));
  }
}

function* fetchFarmByIdSaga(action) {
  try {
    const { farm_id } = action.payload;
    const farmData = yield call(fetchFarmById, farm_id);
    yield put(fetchFarmByIdSuccess(farmData));
  } catch (error) {
    yield put(fetchFarmByIdFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockSaga(action) {
  try {
    const livestockData = yield call(fetchLivestock, action.payload);
    yield put(fetchLivestockSuccess(livestockData));
  } catch (error) {
    yield put(fetchLivestockFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockByIdSaga(action) {
  try {
    const { livestock_id } = action.payload;
    const livestockData = yield call(fetchLivestockById, livestock_id);
    yield put(fetchLivestockByIdSuccess(livestockData));
  } catch (error) {
    yield put(fetchLivestockByIdFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockSurveysSaga(action) {
  try {
    const surveysData = yield call(fetchLivestockSurveys, action.payload);
    yield put(fetchLivestockSurveysSuccess(surveysData));
  } catch (error) {
    yield put(fetchLivestockSurveysFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockProcessingMethodsSaga(action) {
  try {
    const methodsData = yield call(
      fetchLivestockProcessingMethods,
      action.payload,
    );
    yield put(fetchLivestockProcessingMethodsSuccess(methodsData));
  } catch (error) {
    yield put(fetchLivestockProcessingMethodsFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockMeasurementsSaga(action) {
  try {
    const measurementsData = yield call(
      fetchLivestockMeasurements,
      action.payload,
    );
    yield put(fetchLivestockMeasurementsSuccess(measurementsData));
  } catch (error) {
    yield put(fetchLivestockMeasurementsFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockDigitalTwinSaga(action) {
  try {
    const digitalTwinData = yield call(
      fetchLivestockDigitalTwin,
      action.payload,
    );
    yield put(fetchLivestockDigitalTwinSuccess(digitalTwinData));
  } catch (error) {
    yield put(fetchLivestockDigitalTwinFailure(getErrorMessage(error)));
  }
}

function* fetchLivestockDigitalTwinsSaga(action) {
  try {
    const digitalTwinsData = yield call(
      fetchLivestockDigitalTwins,
      action.payload,
    );
    yield put(fetchLivestockDigitalTwinsSuccess(digitalTwinsData));
  } catch (error) {
    yield put(fetchLivestockDigitalTwinsFailure(getErrorMessage(error)));
  }
}

export default function* farmsSaga() {
  yield all([
    takeLatest(fetchFarmsStart.type, fetchFarmsSaga),
    takeLatest(fetchFarmByIdStart.type, fetchFarmByIdSaga),
    takeLatest(fetchLivestockStart.type, fetchLivestockSaga),
    takeLatest(fetchLivestockByIdStart.type, fetchLivestockByIdSaga),
    takeLatest(fetchLivestockSurveysStart.type, fetchLivestockSurveysSaga),
    takeLatest(
      fetchLivestockProcessingMethodsStart.type,
      fetchLivestockProcessingMethodsSaga,
    ),
    takeLatest(
      fetchLivestockMeasurementsStart.type,
      fetchLivestockMeasurementsSaga,
    ),
    takeLatest(
      fetchLivestockDigitalTwinStart.type,
      fetchLivestockDigitalTwinSaga,
    ),
    takeLatest(
      fetchLivestockDigitalTwinsStart.type,
      fetchLivestockDigitalTwinsSaga,
    ),
  ]);
}
